import * as React from 'react';
import { append, includes, without } from 'ramda';
import { useFormField } from '../../../utils/hooks';
export var useCardsAsCheckboxesControls = function useCardsAsCheckboxesControls(props) {
  var _useFormField = useFormField({
      name: props.name
    }),
    _useFormField$meta = _useFormField.meta,
    _useFormField$meta$va = _useFormField$meta.value,
    currentValue = _useFormField$meta$va === void 0 ? [] : _useFormField$meta$va,
    touched = _useFormField$meta.touched,
    _useFormField$helpers = _useFormField.helpers,
    setTouched = _useFormField$helpers.setTouched,
    setValue = _useFormField$helpers.setValue;
  var handleSelectCard = React.useCallback(function (value) {
    var newValue = includes(value, currentValue) ? without([value], currentValue) : append(value, currentValue);
    setValue(newValue);
    if (!touched) {
      setTouched(true);
    }
  }, [currentValue, setValue, touched, setTouched]);
  return {
    handleSelectCard: handleSelectCard,
    value: currentValue
  };
};